<script>
import importApi from "@/api/requests/import";
import { LMS_PROVIDERS } from "@/constants";
import { getUser } from "@/api";
import { mergeUserData } from "@/utils/userUtils";

const platformKey = LMS_PROVIDERS.schoology.key;

export default {
  name: "SchoologyConnectCallback",

  async mounted() {
    try {
      const urlParams = new URLSearchParams(window.location.search);
      const oauthToken = urlParams.get("oauth_token");
      if (!oauthToken) {
        this.showError();
        this.$router.push({ name: "dashboard" });
        return;
      }
      const { data } = await importApi[platformKey].callback(oauthToken);

      if (data?.schoologyProfileId) {
        const { data: userData } = await getUser("me");
        const mergedUserData = mergeUserData(this, userData);
        await this.$store.dispatch("setUser", mergedUserData);

        this.$router.push({
          name: "imports-assignments",
          params: {
            platformKey: platformKey,
            id: data?.schoologyProfileId,
          },
        });
      } else {
        this.showError();
      }
    } catch (error) {
      this.showError();
    }
  },

  methods: {
    showError() {
      this.$showToastError("Failed to connect to Schoology", {
        title: "Error",
      });
    },
  },
};
</script>
